import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import "./LoginModal.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faBuilding, faLock } from '@fortawesome/free-solid-svg-icons';


const LoginModal = ({ show, handleClose }) => {
//   const [show, setShow] = useState(true); // Show modal by default

//   const handleClose = () => setShow(false);

  const redirectToLogin = (type) => {
    if (type === 'business') {
      window.location.href = 'https://web10.secureinternetbank.com/EBC_EBC1151/Login/271070924';
    } else if (type === 'personal') {
      window.location.href = 'https://web10.secureinternetbank.com/PBI_PBI1151/Login/271070924/';
    }
  };

  return (
    <Modal show={show} onHide={handleClose}   centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Login Type</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p>Please choose how you'd like to log in:</p>
        <div className="d-grid gap-2">
          <Button variant="danger" size="lg" onClick={() => redirectToLogin('business')}>
            <h5 className='gn-title text-white'>Business Login</h5>
          </Button>
          <Button variant="danger" size="lg" onClick={() => redirectToLogin('personal')}>
            <h5 className='gn-title text-white'>Personal Login</h5>
          </Button>
        </div>
       
       
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
